import { ImageIcon, BadgeCheck } from "lucide-react";
import { SAMPLE_LABEL } from "@/lib/site";

export const RealBadge = ({ className = "absolute bottom-3 left-3" }) => (
  <span className={`pointer-events-none z-10 inline-flex items-center gap-1.5 rounded-full bg-[var(--green)] px-2.5 py-1 text-[12px] font-semibold text-white ${className}`}>
    <BadgeCheck className="h-3.5 w-3.5" /> Our project
  </span>
);

export const SampleBadge = ({ className = "absolute bottom-3 left-3" }) => (
  <span className={`pointer-events-none z-10 inline-flex items-center gap-1.5 rounded-full bg-white/90 backdrop-blur px-2.5 py-1 text-[12px] font-medium text-slate-700 ${className}`}>
    <ImageIcon className="h-3.5 w-3.5" /> {SAMPLE_LABEL}
  </span>
);
